import logo from './logo.svg';
import './App.css';
import Router from './routing/route';
import './static/css/style.css';
import "./static/css/bootstrap-icons.css";

function App() {
  return (
    <div className="App">
      <Router/>
    </div>
  );
}

export default App;
